module.exports = __webpack_public_path__ + "static/media/Thumbnail.4615239e.png";